import React from 'react';

// This panel renders saved user intent, never current form state or a model's
// claim that the requested material, process or qualification was achieved.
export default function DesignRequirements({ requirements, language = 'en' }) {
  const isTr = language === 'tr';
  const included = Array.isArray(requirements?.must_include)
    ? requirements.must_include.filter((value) => typeof value === 'string' && value.trim()) : [];
  const excluded = Array.isArray(requirements?.must_exclude)
    ? requirements.must_exclude.filter((value) => typeof value === 'string' && value.trim()) : [];
  if (!included.length && !excluded.length) return null;
  return (
    <section className="my-4 rounded-xl border border-cyan-400/30 bg-cyan-950/20 p-4" data-testid="saved-design-requirements">
      <h3 className="text-sm font-semibold text-cyan-200">
        {isTr ? 'Seçilen mühendislik gereksinimleri' : 'Selected engineering requirements'}
      </h3>
      <p className="mt-2 text-xs text-slate-400">
        {isTr
          ? 'Kaydedilen tasarım hedefleri — uygulama ve uygunluk henüz doğrulanmadı. Malzeme, tolerans ve IP sınıfı yalnızca görsele bakılarak doğrulanamaz.'
          : 'Saved design targets — implementation and compliance are not yet verified. Material, tolerance and IP rating cannot be verified from an image alone.'}
      </p>
      {included.length > 0 && <ul className="mt-3 space-y-2 text-sm text-slate-200">
        {included.map((value, index) => <li key={index} className="break-words">• {value}</li>)}
      </ul>}
      {excluded.length > 0 && <div className="mt-3">
        <h4 className="text-xs text-amber-200">{isTr ? 'Hariç tutulanlar' : 'Excluded requirements'}</h4>
        <ul className="mt-2 space-y-2 text-sm text-slate-200">
          {excluded.map((value, index) => <li key={index} className="break-words">• {value}</li>)}
        </ul>
      </div>}
    </section>
  );
}
